import { useState } from 'react'
import type { OnChangeFn, SortingState } from '@tanstack/react-table'
import { TABS } from './utils'

function useFilters() {
  const [selectedTab, setSelectedTab] = useState(0)

  const [isFilterOpen, setFilterOpen] = useState(false)
  function toggleFilterOpen() {
    setFilterOpen((isFilterOpen_) => !isFilterOpen_)
  }

  const [sorting, setSorting] = useState<SortingState>([])
  const handleSortingChange: OnChangeFn<SortingState> = (_sorting) => {
    if (
      selectedTab === TABS.HIGHEST_YELD ||
      selectedTab === TABS.SHORTEST_PERIOD
    ) {
      setSelectedTab(TABS.ALL)
    }

    setSorting(_sorting)
  }

  return {
    selectedTab,
    setSelectedTab,

    isFilterOpen,
    toggleFilterOpen,

    sorting,
    setSorting,
    handleSortingChange,
  }
}

export { useFilters }
